var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconCalendar = function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Weekly")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.81252421%",
    y1: "50%",
    x2: "96.3036737%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4713",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E22",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,4.5 C15.5522847,4.5 16,4.94771525 16,5.5 L16.0000192,6.06301369 C16.8626231,6.28504178 17.5,7.06808721 17.5,8 L17.5,16 C17.5,17.1045695 16.6045695,18 15.5,18 L7.5,18 C6.3954305,18 5.5,17.1045695 5.5,16 L5.5,8 C5.5,7.06808721 6.13737692,6.28504178 6.99998077,6.06301369 L7,5.5 C7,4.94771525 7.44771525,4.5 8,4.5 C8.55228475,4.5 9,4.94771525 9,5.5 L9,6 L13.999,6 L14,5.5 C14,4.94771525 14.4477153,4.5 15,4.5 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-41.7%",
    y: "-29.6%",
    width: "183.3%",
    height: "174.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.488988904   0 0 0 0 0   0 0 0 0 0  0 0 0 0.248634178 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.81252421%",
    y1: "50%",
    x2: "96.3036737%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4713",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E22",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portal-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Weekly-On",
    transform: "translate(-182.000000, -973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Weekly",
    transform: "translate(182.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    x: 7,
    y: 9.5,
    width: 9,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 8,
    y: 11,
    width: 7,
    height: 3,
    rx: 1
  }))))));
};

export default __webpack_public_path__ + "static/media/icon-calendar.2d87c518.svg";
export { SvgIconCalendar as ReactComponent };